import { JSX, useState, useCallback } from 'react';
import { CloseIcon, VideoOffIcon } from '@bg-components/Icon';
import { t } from '@bg-shared';
import classes from './GeoBlockedPopup.module.scss';

export const GeoBlockedPopup = (): JSX.Element => {
    const [open, setOpen] = useState<boolean>(true);

    const closeModal = useCallback(() => {
        setOpen(false);
    }, []);

    if (!open) {
        return null;
    }

    return (
        <>
            <div className={classes.backdrop} />
            <div className={classes.container}>
                <VideoOffIcon className={classes.icon} />
                <div className={classes.title}>
                    <button onClick={closeModal} type="button">
                        <CloseIcon className={classes.closed} />
                    </button>
                    {t.error('GEO_BLOCKING')}
                </div>
            </div>
        </>
    );
};
